import { useTranslation } from 'react-i18next'

import { HomeBasics } from '../components/HomeBasics'
import { CompanyCarousel, CompanyTiles } from '../components/dashboard/CompanyOverview'
import { dashboardSlots } from '../components/dashboard/layout'
import { cardClass } from '../components/ui'
import { NotificationPopup } from '../components/NotificationCenter'
import { can } from '../lib/types'
import {
  useCompanyDashboard,
  usePersonalDashboard,
  useRestrictedDashboard,
} from '../lib/dashboard'
import { useMe } from '../lib/queries'
import { mayShowWhoIsAway } from '../lib/whoIsAway'
import { CalendarSection } from './calendar/CalendarPage'
import { WhoIsAway } from '../components/WhoIsAway'

export default function Dashboard() {
  const { t } = useTranslation()
  const { data: user } = useMe()

  const personal = usePersonalDashboard()
  const company = useCompanyDashboard()
  const restricted = useRestrictedDashboard(user)
  const slots = dashboardSlots({ staff: mayShowWhoIsAway(user), hrView: can(user, 'hr.view') })

  return (
    <>
      {/* Keyed on the identity so starting or stopping a view-as remounts it with that person's own stored count. */}
      {user && <NotificationPopup key={user.id} userId={user.id} canViewAll={can(user, 'staff')} />}

      <section aria-label={t('app.dashboard')} className="@container space-y-4">
        <div className="grid gap-4 @5xl:grid-cols-2">
          <div className="@container min-w-0">
            <HomeBasics user={user} personal={personal.data} personalLoading={personal.isLoading} />
          </div>
          {/* The tile grid and its odd-tile span must read the same container width. */}
          <div className="@container min-w-0">
            <CompanyTiles tiles={slots.tiles} company={company} />
          </div>
        </div>

        <CompanyCarousel slides={slots.slides} company={company} restricted={restricted} />

        {/* The company calendar is `basic`; the people's calendars and day logs are `staff`. */}
        {can(user, 'basic') && (
          <div className={cardClass}>
            <CalendarSection companyOnly={!can(user, 'staff')} />
          </div>
        )}

        {mayShowWhoIsAway(user) && (
          <div className={cardClass}>
            <WhoIsAway />
          </div>
        )}
      </section>
    </>
  )
}
